module.exports = __webpack_public_path__ + "static/media/icon_channel_record.5cbb0f3d.svg";